import { tv } from 'tailwind-variants'

import { body1, body2, caption, h3 } from '@ui-kit/core/typography'

export const stepContent = tv({
  slots: {
    loadingContainer: 'fixed -z-10 flex h-full w-full flex-col items-center justify-center',
    successContainer: 'flex w-full flex-1 flex-col items-center overflow-auto',
    contentContainer: 'w-full max-w-lg flex-1 gap-y-4',
    wideStepContentContainer: 'w-full max-w-[649px] flex-1 gap-y-4',
    footerContent: 'flex w-full max-w-[560px] flex-1 flex-row gap-x-5 px-4',
    backButton:
      'inline-flex items-center justify-center rounded-lg border border-black px-4 transition duration-300 hover:opacity-70 active:opacity-70',
    continueButtonLabelWrapper: 'z-10 flex-1',
    stickyPrice: 'flex-1 flex-row items-baseline gap-1 xl:hidden',
    stickyPriceValue: 'font-inter-semibold text-[24px] leading-[1.2] text-black',
    stickyPriceInterval: body2({ color: 'grey700' }),
    backButtonImageContainer: 'relative h-6 w-6',
    backButtonImage: 'h-6 w-6',
    dismissButton:
      'items-center justify-center rounded-lg border border-black px-4 py-3 text-center',
    transferFlowButtonsWrapper: 'flex flex-1 flex-col gap-y-2',
    viewProductsButtonText:
      'text-left font-modern-era-medium text-sm uppercase leading-7 text-ui-light',
    viewProductsButtonWrapper:
      'items-center justify-center rounded-lg border border-black bg-black px-4 py-3 text-center',

    // Layout wrappers
    wideContentWrapper: 'relative w-full max-w-[1360px] xl:min-h-[calc(100vh-260px)]',
    successContentWrapper: 'mx-auto w-full',

    // Order summary card
    orderSummaryCard: 'mt-6 rounded-2xl border border-grey-200 bg-grey-100 px-6 py-6 xl:hidden',
    orderSummaryColumn:
      'hidden xl:absolute xl:bottom-0 xl:right-0 xl:top-[86px] xl:flex xl:w-[400px]',
    orderSummaryCardDesktop:
      'mt-6 hidden w-[320px] rounded-2xl border border-grey-200 bg-grey-100 px-6 py-6 xl:absolute xl:right-0 xl:top-0 xl:mt-0 xl:flex',

    // OTP Modal
    otpOverlay: 'fixed inset-0 z-50 flex items-center justify-center bg-black/50',
    otpCard: 'mx-4 w-full max-w-lg rounded-2xl bg-white p-6',
    otpHeader: 'mb-4 flex-row items-center justify-between',
    otpTitle: h3({ color: 'black' }),
    otpCloseButton: body1({}),
    otpDescription: [body2({ color: 'grey700' }), 'mb-6'].join(' '),
    otpErrorBox: 'mb-4 rounded-lg bg-error-light p-3',
    otpErrorText: caption({ color: 'error' }),
    otpInput: ['mb-4 rounded-lg border border-grey-300 px-4 py-3', body2({})].join(' '),
    otpResendButton: 'mb-6 mt-4 items-center',
    otpResendText: body2({ bold: true }),
    otpConfirmButton: 'w-full items-center rounded-lg bg-black py-4',
    otpConfirmText: body2({ color: 'white', bold: true }),

    purchaseErrorBanner: 'mb-4 rounded-lg bg-error-light p-3',
    purchaseErrorText: body2({ color: 'error' }),

    stepValidationAlert: 'mb-6',
  },
  variants: {
    resendDisabled: {
      true: { otpResendText: 'text-grey-400' },
      false: { otpResendText: 'text-black' },
    },
    newDesign: {
      true: {
        successContainer: '-mt-[26px] lg:mt-0',
        footerContent: 'mx-auto items-center gap-x-3 px-0 xl:gap-x-5 xl:px-4',
        backButton: 'hidden h-button xl:inline-flex',
      },
    },
    alignFooterWithContent: {
      true: { footerContent: 'xl:ml-auto xl:mr-[525px] xl:max-w-[600px] xl:px-0' },
    },
    wideOrderSummary: {
      true: {
        contentContainer: 'xl:mr-[525px] xl:max-w-[600px]',
        orderSummaryCard: 'mt-1.5 rounded-none border-0 bg-transparent p-0',
        successContainer: 'xl:overflow-visible',
        orderSummaryCardDesktop: 'w-[400px] rounded-[16px] border-0 p-8 xl:sticky xl:top-[122px]',
      },
    },
  },
  defaultVariants: { resendDisabled: false },
})
